import React, { Component } from 'react';
import {
  AppBar,
  Toolbar,
  Typography,
  Menu,
  MenuItem,
  Button,
  ListItemIcon,
  Link,
  IconButton,
} from '@material-ui/core';
import { Person, ArrowDropDown, ExitToApp, Home, Menu as MenuIcon } from '@material-ui/icons';
import withTheme from '@material-ui/core/styles/withTheme';
import { getCookie } from '../../utils/utils';
import logoblanco from '../../img/logo-white.svg';
class Header extends Component {
  constructor(props) {
    super(props);
    this.state = {
      anchorEl: null,
      smallScreen: false,
      showMenu: false,
    };
  }

  componentDidMount() {
    window.addEventListener('resize', this.resize.bind(this));
    this.resize();
  }

  resize() {
    this.setState({ smallScreen: window.innerWidth <= 630, showMenu: window.innerWidth <= 959 });
  }

  handleClose = () => this.setState({ anchorEl: null });

  handleMenu = event => this.setState({ anchorEl: event.currentTarget });

  render() {
    let open = Boolean(this.state.anchorEl);

    return (
      <AppBar
        style={{ zIndex: 900, backgroundColor: '#25265d', padding: '0.5rem' }}
        position="static"
      >
        <Toolbar style={{ justifyContent: 'space-between' }}>
          <div>
            {this.state.showMenu && (
              <IconButton
                onClick={() => this.props.handleDrawerToggle()}
                style={{ padding: '0 10px 0 0' }}
              >
                <MenuIcon style={{ color: 'white' }} />
              </IconButton>
            )}
            <div style={{ display: 'flex', alignItems: 'baseline', gap: 15 }}>
              <img alt={'data'} src={logoblanco} style={{height: "2rem"}}/>
              {/* <Link style={{ textDecoration: 'none' }} href={this.props.link}>
                <Typography variant="h6" style={{ color: 'white' }}>
                  {!this.state.smallScreen && this.props.title}
                </Typography>
              </Link> */}
            </div>
          </div>
          <div style={{ display: 'flex' }}>
            { JSON.parse(getCookie('routeOptions')).length === 0 ? null : (
              <Link style={{ color: 'white', textDecoration: 'none' }} href={`#${JSON.parse(getCookie('routeOptions'))[0].path}`}>
                <Button startIcon={<Home />} style={{ height: '100%' }} color="inherit">
                  Panel de control
                </Button>
              </Link>
            )}
            <Button
              onClick={this.handleMenu}
              color="inherit"
              startIcon={<Person />}
              endIcon={<ArrowDropDown />}
              style={{
                paddingTop: this.state.smallScreen ? 10 : 12,
                paddingBottom: this.state.smallScreen ? 10 : 12,
                color: 'white',
              }}
            >
              {getCookie('name')}
            </Button>
            <Menu
              id="menu-appbar"
              anchorEl={this.state.anchorEl}
              elevation={1}
              getContentAnchorEl={null}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'center',
              }}
              keepMounted
              transformOrigin={{
                vertical: 'top',
                horizontal: 'center',
              }}
              open={open}
              onClose={this.handleClose}
            >
              <MenuItem onClick={this.props.logout} style={{ padding: 12 }}>
                <ListItemIcon>
                  <ExitToApp style={{ color: 'grey' }} />
                </ListItemIcon>
                <Typography variant="inherit" style={{ color: 'rgba(0,0,0,0.7)' }}>
                  Cerrar sesión
                </Typography>
              </MenuItem>
            </Menu>
          </div>
        </Toolbar>
      </AppBar>
    );
  }
}

export default withTheme(Header);
